// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"c62033a2","86":"29ecb358","148":"6a65d17e","227":"5bcd232c","257":"db9806d5","453":"e3813987","607":"472dcc56","661":"1545214e","722":"e7a50730"}[chunkId] + ".chunk.js";
};